import React from 'react'
import styled from 'styled-components';
import { Header, Checkbox } from 'semantic-ui-react'
import { Box, Flex } from 'rebass'

import { __ } from '~/i18n'

import { CheckoutButtons } from '~/components/checkout'
import Link from '~/components/link'

import logic from './logic'
import ContactSummary from '~/components/contact-summary'
import PaymentMethodSummary from './payment-method-summary'
import ShippingMethodSummary from './shipping-method-summary'

const SummaryStepContainer = styled.div``;
const SummaryContainer = styled.div`
  padding: 40px 0 75px;
  
  @media (max-width: 768px) {
    padding: 35px 0 20px;
  }
`;

@logic
export default class SummaryStep extends React.PureComponent {
  handleContinue = () => {
    const { next } = this.props.actions;

    next();
  };

  handleNavigateToContact = (e) => {
    e.preventDefault();
    // TODO: fix magic strings
    this.handleNavigate('contact', 'insertcontact')
  };

  handleNavigateToShipping = (e) => {
    e.preventDefault();
    // TODO: fix magic strings
    this.handleNavigate('delivery', 'deliver')
  };

  handleNavigateToPayment = (e) => {
    e.preventDefault();
    // TODO: fix magic strings
    this.handleNavigate('payment', 'pay')
  };

  handleNavigate = (step, action) => {
    const { navigate } = this.props.actions;

    navigate(step, action)
  };

  render() {
    const {
      onBack,
      allowContinue,
      termsLink,
      termsChecked,
      mustAgreeTerms,
      loading,
      contact,
      shippingContact,
      shippingRequired,
      activeCart,
      shopPaymentMethods,
      shopShippingMethods
    } = this.props;
    const { setTermsCheckbox } = this.props.actions;

    return (
      <SummaryStepContainer>
        <Header size='large'>{ __("Review Order") }</Header>
        <Header.Subheader>{ __("Review your order and make sure everything is correct.") }</Header.Subheader>

        <SummaryContainer>
          <Flex flexWrap='wrap' py={ [0,4] } mx={ -4 }>
            <Box px={ 4 } pb={[6,0]} width={ [ 1, 0.5 ] }>
              <Header>{ __('Customer information') }</Header>
              <ContactSummary contact={ contact } />
              <Link href='#' onClick={ this.handleNavigateToContact } >{ __('Edit') }</Link>
            </Box>
            { shippingRequired ? <Box px={ 4 } pb={[6,0]} width={ [ 1, 0.5 ] }>
              <Header>{ __('Shipping address') }</Header>
              <ContactSummary contact={ shippingContact } />
              <Link href='#' onClick={ this.handleNavigateToShipping } >{ __('Edit') }</Link>
            </Box> : null }
          </Flex>
          <Flex flexWrap='wrap' py={ [0, 4] } mx={ -4 }>
            { shippingRequired ? <Box px={ 4 } pb={[6,0]} width={ [ 1, 0.5 ] }>
              <Header>{ __('Shipping method') }</Header>
              <ShippingMethodSummary cart={ activeCart } shippingMethods={ shopShippingMethods } />
              <Link href='#' onClick={ this.handleNavigateToShipping } >{ __('Edit') }</Link>
            </Box> : null }
            <Box px={ 4 } pb={[6,0]} width={ [ 1, 0.5 ] }>
              <Header>{ __('Payment method') }</Header>
              <PaymentMethodSummary cart={ activeCart } paymentMethods={ shopPaymentMethods } />
              <Link href='#' onClick={ this.handleNavigateToPayment } >{ __('Edit') }</Link>
            </Box>
          </Flex>
        </SummaryContainer>

        { mustAgreeTerms ? <Checkbox label={
          <label>
            { __("You must agree to the sales") }
            {' '}
            <Link href={ termsLink } target="_blank" inline>{ __("terms")}</Link>
          </label>
        }
          checked={ termsChecked }
          onChange={ (e, {checked}) => {
            setTermsCheckbox(checked);
          }}
        /> : null }
        <CheckoutButtons
          onBack={ onBack }
          onContinue={ this.handleContinue }
          continueDisabled={ !allowContinue }
          loading={ loading }
        />
      </SummaryStepContainer>
    )
  }
}
